<template>
  <div>
    <div class="col-12 text-center box box-radius">
      <input :id="id" class="hidden" type="file" @change="onChange" />
      <img src="@/assets/images/Upload.png" alt />
      <img v-if="value" class="box-cover box-radius image-cover" :src="value" alt />
      <p class="box-text">{{ text }}</p>
      <label :for="id" class="box-cover no-visibility">{{ text }}</label>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: "Upload",
    },
    id: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      default: "",
    },
  },
  methods: {
    onChange(e) {
      const file = e.target.files[0];
      if (this.validateFileSize(file)) {
        const reader = new FileReader();
        reader.onload = (e) => {
          if (this.isEvent(e)) {
            const image = e.target.result;
            this.image = image;
            this.$emit("value", image);
            this.$emit("change", image);
          }
        };
        reader.readAsDataURL(file);
      }
    },
    validateFileSize(file) {
      const FileSize = file.size / 1024 / 1024; // in MB
      if (FileSize > 2) {
        this.$toasted.info("File size exceeds 2 MB..please select different file.");
        return false;
      } else {
        return true;
      }
    },
    isEvent(e) {
      return e && e.target !== null && e.target !== undefined && e.target.result;
    },
  },
};
</script>

<style scoped>
.box {
  padding: 40px 0px;
  background: #e9e7ff;
  border: 1px dashed #3635d3;
}

.box-radius {
  border-radius: 12px;
}

.box-text {
  font-weight: bold;
  padding-top: 5px;
}

.hidden {
  display: none;
  height: 1px;
  width: 1px;
}

.box-cover {
  height: 100%;
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
}

.no-visibility {
  opacity: 0;
}

.image-cover {
  object-fit: contain;
}

</style>
